/** Do not edit directly **/
/** Do not edit directly **/
/**
 * @prop --sy-dialog-footer-padding: Dialog footer padding.
 * @prop --sy-dialog-footer-buttons-border-radius: Dialog footer buttons border radius.
 * @prop --sy-dialog-footer-buttons-margin: Dialog footer buttons margin.
 * @prop --sy-dialog-footer-buttons-padding-x: Dialog footer buttons horizontal padding.
 * @prop --sy-dialog-footer-buttons-padding-y: Dialog footer buttons vertical padding.
 */
*,
:host,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  display: flex;
  flex-wrap: wrap;
  justify-content: "flex-start";
  padding: var(--sy-dialog-footer-padding, var(--sy-spacer-4));
}
:host sy-button {
  margin: 0 var(--sy-dialog-footer-buttons-margin, var(--sy-spacer-2));
  --sy-button-border-radius: var(--sy-dialog-footer-buttons-border-radius, var(--sy-border-radius-rounded));
  --sy-button-padding-x: var(--sy-dialog-footer-buttons-padding-x, var(--sy-spacer-4));
  --sy-button-padding-y: var(--sy-dialog-footer-buttons-padding-y, var(--sy-spacer-3));
  --sy-button-background-color-hover-basic: var(--sy-surface-elevated-hover);
}